import * as React from "react";
import { TableBody, TableCell, TableHead, TableRow, Stack, Typography, Pagination, useTheme, Box, MenuItem, IconButton } from "@mui/material";
import SearchTxtField from "../../../components/SearchTxtField";
import route from "../../../utils/Routes";
import { useNavigate, useSearchParams } from "react-router-dom";
import StyledTableContainer from "../../../components/StyledTableContainer";
import { useState } from "react";
import { formatName, formatUserType, isNotEmpty } from "../../../utils/format";
import { useAuthContext } from "../../../context/AuthContext";
import { useQuery } from "react-query";
import QueryKey from "../../../utils/QueryKey";
import { useEffect } from "react";
import { customAlert } from "../../../components/notify";
import { ArrowDropDown } from "@mui/icons-material";
import DDMenu from "../../../components/DDMenu";
import { getSrcComEmpServ } from "../../../services/source-service";
import StyledSwitch from "../../../components/StyledSwitch";
import constants from "../../../utils/Constants";


const columns = [
  {
    id: 'empName',
    label: "Employee Name",
    align: 'left',
    minWidth: 150,
  },
  {
    id: 'empId',
    label: "Employee ID",
    align: 'left',
    minWidth: 150
  },
  {
    id: 'username',
    label: "Email ID",
    align: 'left',
    minWidth: 150,
  },
  {
    id: 'role',
    label: "Employee Role",
    align: 'left',
    minWidth: 150
  },
  {
    id: 'isApproved',
    label: "Approval Status",
    align: 'left',
    minWidth: 150
  },
  {
    id: 'status',
    label: "Status",
    align: 'center',
    minWidth: 50
  }
];


const userTypeArr = [
  ...(constants.needRequestor ? [{ value: "requestor", label: "Requestor" }] : []),
  { value: "approver", label: "End User" },
  { value: "focal_point", label: "Contract Focal Point" },
  { value: "line_manager", label: "Contract Owner" }
];

function ComEmpSrc({ aComId, type = 'amtc' }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const { setLoadingScreen, ctxtUser } = useAuthContext();
  const limit = type === 'amtc' ? 7 : 10;
  const [searchParams, setSearchParams] = useSearchParams();
  const pgNo = parseInt(searchParams.get("pgNo") || "1");
  const querySearchWord = searchParams.get("s") || "";
  const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
  const [isSrchBtnClick, setIsSrchBtnClick] = useState(0)
  const comId = type === 'amtc' ? aComId : ctxtUser?.comId;
  const currProj = JSON.parse(localStorage.getItem('currProj') || "{}");
  const selUserType = searchParams.get("ut") || "";
  // const [selUserType, setSelUserType] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const { isLoading, isError, error, data: empData } = useQuery([QueryKey.comEmpList, pgNo, comId, isSrchBtnClick, selUserType],
    () => getSrcComEmpServ({ comId, limit, pageNumber: pgNo, searchWord, userType: selUserType, sourceUserId: ctxtUser?.userId }), {
    enabled: (isNotEmpty(comId) && isNotEmpty(ctxtUser?.userId)),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    keepPreviousData: true
  });


  useEffect(() => {
    setLoadingScreen(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  async function onSearchBtnClick(e) {
    setIsSrchBtnClick((prevVal) => ++prevVal)
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      return prev
    }, { replace: true })
  }

  function onSearch(e) {
    setSearchWord(e.target.value)
    setSearchParams(prev => {
      prev.set("s", encodeURIComponent(e.target.value))
      return prev
    }, { replace: true })
  }

  function handleOnClear(e) {
    setIsSrchBtnClick((prevVal) => ++prevVal)
    setSearchWord("");
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      prev.set("s", "")
      return prev
    }, { replace: true })
  }

  const handleRowClick = (userId) => {
    if (type === "amtc")
      navigate(`${route.aComUserProfile}/?userId=${userId}`);
    else
      navigate(`${route.cUserProfile}/?userId=${userId}`);
  };



  const handlePageChange = async (event, value) => {
    //    setPageNumber(value);
    setSearchParams(prev => {
      prev.set("pgNo", value)
      return prev
    }, { replace: true })
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleRoleSelect = (role) => {
    //  setSelUserType(role); // Update the selected status
    setSearchParams(prev => {
      prev.set("ut", role)
      return prev
    }, { replace: true })
    handleMenuClose();
  };

  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }
  return (
    <Box height={type === 'amtc' ? "90%" : "100%"} width={"100%"} px={type === 'amtc' ? 2 : 0}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1, pl: 1, pr: 3 }} width={"100%"}>
        <Stack width={"20%"} >
          <Typography sx={{ fontSize: 18, fontWeight: 500, }}>Employee List</Typography>
        </Stack>
        <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} width={400}>
          <SearchTxtField width={"100%"} handleOnClear={handleOnClear} searchKeyWord={searchWord} onSearch={onSearch} onBtnClick={onSearchBtnClick}
            placeholder="Search Emp By Name / Email / EmpId..." />
        </Stack>
        <Stack direction={"row"} justifyContent="end" alignItems={"center"} gap={2} width={"20%"} >
        </Stack>
      </Stack>

      {empData && <StyledTableContainer height={"81%"} isStickyHeader={true}>
        <TableHead>
          <TableRow >
            {columns.map((column) => (
              <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                {column.label}
                {column.id === 'role' && (
                  <div style={{ marginTop: -33, marginLeft: 100, height: 35 }} >
                    <IconButton aria-haspopup="true" onClick={handleMenuOpen}>
                      <ArrowDropDown />
                    </IconButton>
                  </div>
                )}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {(empData?.empArr || []).map((i) => {
            return (
              <React.Fragment key={i?.id}>
                <TableRow hover tabIndex={-1} onClick={() => handleRowClick(i?.userId)}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, height: 50, cursor: 'pointer' }} >
                  {columns.map((column) => {
                    const value = i[column.id];
                    switch (column.id) {
                      case "empName":
                        return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                          {formatName(i?.fName, i?.lName)}
                        </TableCell>
                      case "role":
                        return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                          {formatUserType(i?.userType)}
                        </TableCell>
                      case "isApproved":
                        return <TableCell key={column.id} align={column.align} sx={{
                          textAlign: column.align, fontSize: 13,
                          color: value === 1 ? "green" : "orange"
                        }}>
                          {formatUserType(value)}
                        </TableCell>
                      case "status":
                        return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                          <StyledSwitch checked={i?.status === 1 ? true : false} disabled={true} />
                        </TableCell>
                      default:
                        return (
                          <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                            {(value === null || value === "" || value === "null") ? "NA" : value}
                          </TableCell>
                        );
                    }
                  })}
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </StyledTableContainer>}
      <Stack sx={{ alignItems: "center", mt: 2 }}>
        <Pagination count={Math.ceil(empData?.totalEmpCount / limit) || 0} color="primary" page={pgNo} onChange={handlePageChange}
          variant="outlined" shape="rounded" />
      </Stack>
      <DDMenu open={open} handleClose={handleMenuClose} anchorEl={anchorEl} >
        <MenuItem onClick={() => handleRoleSelect("")}> All</MenuItem>
        {userTypeArr.map((i) => <MenuItem onClick={() => handleRoleSelect(i.value)} key={i.label}>
          {i.label}
        </MenuItem>)}
      </DDMenu>
    </Box>
  );
}


export default ComEmpSrc;